import { loadModal } from '../../AsyncLoader';
import SyosPageComponent from '../components/SyosPageComponent';
import SyosEvents from '../utils/SyosEvents';

const SyosAjaxErrorModal = {
  open(syosController) {
    loadModal().then((Modal) => {
      Modal.alert({
        title: SyosPageComponent.ajaxErrorModalTitle,
        bodyContents: SyosPageComponent.ajaxErrorModalMessage,
        beforeRemove: () => {
          syosController.emit(SyosEvents.MODAL_CLOSE);
        },
      });
    });
  },
};

export default SyosAjaxErrorModal;
